import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Recommend from "@components/Recommend";
import { getProducts } from "@api/store";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";
export default {
  name: "GoodsList",
  components: {
    Recommend: Recommend,
    Loading: Loading
  },
  props: {},
  data: function data() {
    var _this$$route$query = this.$route.query,
        _this$$route$query$s = _this$$route$query.s,
        s = _this$$route$query$s === void 0 ? "" : _this$$route$query$s,
        _this$$route$query$id = _this$$route$query.id,
        id = _this$$route$query$id === void 0 ? 0 : _this$$route$query$id,
        _this$$route$query$ti = _this$$route$query.title,
        title = _this$$route$query$ti === void 0 ? "" : _this$$route$query$ti;
    return {
      hostProduct: [],
      productList: [],
      Switch: true,
      where: {
        page: 1,
        limit: 8,
        keyword: s,
        sid: id,
        //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false
    };
  },
  watch: {
    title: function title() {
      this.updateTitle();
    },
    $route: function $route(to) {
      if (to.name !== "GoodsList") return;
      var _to$query = to.query,
          _to$query$s = _to$query.s,
          s = _to$query$s === void 0 ? "" : _to$query$s,
          _to$query$id = _to$query.id,
          id = _to$query$id === void 0 ? 0 : _to$query$id,
          _to$query$title = _to$query.title,
          title = _to$query$title === void 0 ? "" : _to$query$title;

      if (s !== this.where.keyword || id !== this.where.sid) {
        this.where.keyword = s;
        this.loadend = false;
        this.loading = false;
        this.where.page = 1;
        this.where.sid = id;
        this.title = title && id ? title : "";
        this.nows = false;
        this.$set(this, "productList", []);
        this.price = 0;
        this.stock = 0;
        this.get_product_list();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.updateTitle();
    this.get_product_list();
    this.$scroll(this.$refs.container, function () {
      !_this.loading && _this.get_product_list();
    });
  },
  methods: {
    // 商品详情跳转
    goDetail: function goDetail(item) {
      var _this2 = this;

      goShopDetail(item).then(function () {
        _this2.$router.push({
          path: "/detail/" + item.id
        });
      });
    },
    updateTitle: function updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    get_product_list: debounce(function () {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；

      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；

      that.loading = true;
      this.setWhere();
      var q = that.where;
      getProducts(q).then(function (res) {
        that.loading = false;
        that.productList.push.apply(that.productList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；

        that.where.page = that.where.page + 1;
      });
    }, 300),
    submitForm: function submitForm() {
      this.$set(this, "productList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.get_product_list();
    },
    //点击事件处理
    set_where: function set_where(index) {
      var that = this;

      switch (index) {
        case 0:
          return that.$router.push({
            path: "/category"
          });

        case 1:
          if (that.price === 0) that.price = 1;else if (that.price === 1) that.price = 2;else if (that.price === 2) that.price = 0;
          that.stock = 0;
          break;

        case 2:
          if (that.stock === 0) that.stock = 1;else if (that.stock === 1) that.stock = 2;else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          break;

        case 3:
          that.nows = !that.nows;
          break;

        default:
          break;
      }

      that.$set(that, "productList", []);
      that.where.page = 1;
      that.loadend = false;
      that.get_product_list();
    },
    //设置where条件
    setWhere: function setWhere() {
      var that = this;

      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }

      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }

      that.where.news = that.nows ? "1" : "0";
    },
    switchTap: function switchTap() {
      var that = this;
      that.Switch = !that.Switch;
    }
  }
};